import { Models } from "@hex-insights/app-modules";
import { Address } from "../../../Utilities";

// Note: the functions defined in this file can be passed to model field components for consistent formatting.

/**
 * Formats the name field of the Address model.
 */
export function name(value: Address["name"]): string {
	if (!value) {
		return "Address";
	}

	return Models.toString(value) + " Address";
}

/**
 * Formats the addressLine1 field of the Address model.
 */
export function addressLine1(value: Address["addressLine1"]): string {
	return Models.toString(value);
}

/**
 * Formats the addressLine2 field of the Address model.
 */
export function addressLine2(value: Address["addressLine2"]): string {
	return Models.toString(value);
}

/**
 * Formats the city field of the Address model.
 */
export function city(value: Address["city"]): string {
	return Models.toString(value);
}

/**
 * Formats the postalCode field of the Address model.
 */
export function postalCode(value: Address["postalCode"]): string {
	return Models.toString(value);
}

/**
 * Formats the stateOrProvince field of the Address model.
 */
export function stateOrProvince(value: Address["stateOrProvince"]): string {
	return Models.toString(value);
}
